<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/t4VtFq/tc-custom/9780795335020.jpg?1737686686170" alt="This image is the cover for the book Prizzi's Honor, Prizzi"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Prizzi's Honor, Prizzi
      </h1>
      <p class="bookDescription body article font2">
        <b>A darkly funny novel of mobsters, murder, and marriage: “The surprise ending will knock your reading glasses off.” —<i>The New York Times</i></b><br/>  <br/> Charley Partanna works as a hitman for the Prizzis, New York’s most dangerous crime family. When he meets Irene Walker, an LA-based tax consultant, it’s pretty much love at first sight.<br/>  <br/> But Irene also moonlights as a hit woman—and had a hand in a big-money heist in Vegas. Now Charley has been told that she’s got to go. Faced with divided loyalties, he must make a choice—between the only family he’s ever known and the woman he loves.<br/>  <br/> A New York Times Notable Book and made into an award-winning film, <i>Prizzi’s Honor</i> is a dark, rollicking read from an “old pro at mixing satire with suspense” (<i>The New York Times</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Condon
      </h2>
      
      <p class="authorDescription body article">Richard Condon (1915&ndash;1996) is a political novelist from New York who wrote over twenty-six satirical thrillers throughout a prolific career--dealing with themes of political corruption, greed, and abuse of power. Before his career as a novelist, Condon served in the US Merchant Marines and later became a Hollywood publicist, agent, and advertising writer. Condon&#39;s best-selling works include <I>The Manchurian Candidate</I> and the Prizzi series, dealing with the life of a crime family in New York. <I>The Manchurian Candidate</I> was made into a movie twice, once in 1962 and again in 2004. The 1962 movie starred Frank Sinatra and Angela Lansbury, who was nominated for an Academy Award as Best Supporting Actress for her role.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      RosettaBooks, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7af3a0b0